import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { InfoPagesLayout } from 'Components/InfoPagesLayout/InfoPagesLayout';
import { InfoPagesLayoutDisona } from 'Components/InfoPagesLayout/disona/InfoPagesLayoutDisona';
import routes from 'common/constants/routing.constants';

import initFreshChat from 'initFreshChat';
import { appConfig } from 'config';
import CopySvg from '../../common/assets/icons/common/actions/white-copy.svg';
import { S } from './styled';

export const TransactionStatus = ({
  data: { status, currency, amount, transactionGuid },
}) => {
  const { t } = useTranslation();
  const isSuccess = ['success', 'successful', 'done', 'yes'].includes(status);
  const details = currency && amount && `(${amount} ${currency})`;
  const onCopy = () => {
    navigator.clipboard.writeText(transactionGuid);
  };

  useEffect(() => {
    if (window.top === window.self) {
      window.postMessage('rw_tx_status_page', '*');
      initFreshChat();
    } else {
      window.top.postMessage('rw_tx_status_page', '*');
    }
  }, []);

  return (
    <div>
      {appConfig.whiteLabelPartner === 'disona' ? (
        <InfoPagesLayoutDisona
          error={!isSuccess}
          to={routes.operations.path}
          linkText={t('common.disona.transactionStatus.goToOperations')}
          currency={currency}
          amount={amount}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: isSuccess
                ? t('common.disona.transactionStatus.success')
                : t('common.disona.transactionStatus.fail'),
            }}
          />
          {/* {!isSuccess && transaction_guid && (
            <>
              <S.TxDetails onClick={onCopy}>
                Transaction ID: {transaction_guid} <S.CopyIcon src={CopySvg} />
              </S.TxDetails>
            </>
          )} */}
        </InfoPagesLayoutDisona>
      ) : (
        <InfoPagesLayout
          error={!isSuccess}
          to={routes.operations.path}
          linkText={t('common.transactionStatus.goToOperations')}
        >
          <div
            dangerouslySetInnerHTML={{
              __html: isSuccess
                ? t('common.transactionStatus.success', { details })
                : t('common.transactionStatus.fail'),
            }}
          />
          {!isSuccess && transactionGuid && (
            <S.TxDetails onClick={onCopy}>
              Transaction ID: {transactionGuid} <S.CopyIcon src={CopySvg} />
            </S.TxDetails>
          )}
        </InfoPagesLayout>
      )}
    </div>
  );
};
